<div *ngIf="accessErrorMessage" class="mc-project-files-access-error-message-wrapper" [matTooltip]="accessErrorMessage">
  <mat-icon fontSet="project-titan" fontIcon="icon-readonly" class="mc-toolbar-icon text-large"></mat-icon>
  &nbsp;
  <span class="mc-toolbar-text">
    Read only
  </span>
  &nbsp;
  <mat-icon color="info" fontSet="project-titan" fontIcon="icon-info" class="mc-toolbar-icon text-large"></mat-icon>
</div>